export default actionPages = (Q) -> [
  {
    key: 'create-person'
    title: 'Create Employee'
    closeLabel: null
    component: 'sequenced_form'
    service: {}
    formSequence:
      onSave:
        confirmation: 'Say hello to your new team member!'
        node:
          typeNode: 'Employee'
          typeLabel: 'Employee'
        # config:
        #   graph: '$config'
      queries: []
      formFields: [{
        formItem: 'name'
        formItemLabel: 'Name'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'Name is required.' }]
      }, {
        formItem: 'age'
        formItemLabel: 'Age'
        formItemType: 'number'
      }, {
        formItem: 'type'
        formItemLabel: 'Type'
        formItemType: 'select'
        derivedData:
          querySource: 'type'
          labelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'hasType'
      }, {
        formItem: 'subtype'
        formItemLabel: 'Subtype'
        formItemType: 'select'
        derivedData:
          querySource: 'subtype'
          labelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'hasSubtype'
      }, {
        formItem: 'contractPeriod'
        formItemLabel: 'Contract period'
        formItemType: 'dateRange'
        formItemPlaceholder: ['Hired on','Contract expires']
        save:
          attributes: ['hiredOn', 'contractExpires']
          relationThrough: {
            relationName: 'hasContract'
            rules: [{
              type: 'relation'
              key: 'type'
              to: 'Contract'
            }]
          }
      }, {
        formItem: 'mentor'
        formItemLabel: 'Mentor'
        formItemType: 'select'
        derivedData:
          querySource: 'employee'
          labelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'hasMentor'
      }, {
        formItem: 'os'
        formItemLabel: 'Uses OS'
        formItemType: 'selectOrCreate'
        config:
          className: 'OperatingSystem'
          createForm: 'create-os'
        derivedData:
          querySource: 'os'
          labelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'hasMachine'
          relationThrough: {
            relationName: 'hasInstalledOs'
            rules: [{
              type: 'relation'
              key: 'type'
              to: 'Computer'
            }]
          }
      }, {
        formItem: 'languageCount'
        formItemLabel: 'Number of programming languages employee is proficient in'
        formItemType: 'number'
      }, {
        formItem: 'why'
        formItemLabel: 'If you don\'t know any programming languages, how are you a developer?'
        formItemType: 'string'
        config:
          conditions: [{
            key: 'languageCount'
            type: 'LESS_THAN'
            value: 1
          }]
      }, {
        formItem: 'languages'
        formItemLabel: 'Programming languages'
        formItemType: 'selectOrCreate'
        config:
          # repeatOnConf:
          # 'formFieldName' - lookup the value at the input,
          # OR
          # {
          #   item: String - form field address,
          #   key: String - property accessor path,
          #   type: 'count'|'attr'
          # }
          repeatOn: 'languageCount'

          # conditional rendering conf:
          # 'formFieldName' - lookup the truthiness of the form field value,
          # OR
          # {
          #   key: String - form field address,                         # This will be the left-hand side of the comparator expression
          #   type: EQUAL_TO | NOT_EQUAL_TO | GREATER_THAN | LESS_THAN # This will be the operator for the comparator expression
          #   value: value to evaluate condition based                 # This will be the right-hand side of the comparator expression
          # }
          conditions: [{
            key: 'languageCount'
            type: 'GREATER_THAN'
            value: 0
          }]
          createForm: 'create-language'
          className: 'ProgrammingLanguage'
        derivedData:
          querySource: 'languages'
          labelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'isFluentIn'
      }, {
        formItem: 'isRemote'
        formItemLabel: 'Working remotely?'
        formItemType: 'switch'
        save:
          onKey: { value: true, label: 'Yes (isn\'t everyone nowadays?)' }
          offKey: { value: false, label: 'No' }
      }]
      sequence: [{
        fields: ['name', 'age', 'type', 'subtype', 'languageCount', 'isRemote']
      }, {
        fields: ['os', 'languages', 'why', 'mentor', 'contractPeriod']
      }]
  }, {
      key: 'create-os'
      title: 'Create Operating System'
      hidden: true
      component: 'sequenced_form'
      formSequence:
        onSave:
          confirmation: 'Operating system was successfully created'
          node:
            typeNode: "OperatingSystem"
            typeLabel: 'OS'
        formFields: [{
          formItem: 'name'
          formItemLabel: 'Name'
          formItemType: 'string'
          formItemRules: [{ required: true, message: 'Name is required' }]
        }, {
          formItem: 'processorType'
          formItemLabel: 'Processor Type'
          formItemType: 'radio'
          formItemRules: [{ required: false }]
          options: [{ value: 32, label: '32-bit' }, { value: 64, label: '64-bit' }]
        }]
        sequence: [{
          fields: ['name', 'processorType']
        }]
  }, {
    key: 'create-language'
    title: 'Create Programming Language'
    hidden: true
    component: 'sequenced_form'
    formSequence:
      onSave:
        confirmation: '14n9u4age cr3473d 5ucc355fu11y, 13t a n3w g3n3r4t10n 0f 1337\'5 r3j01c3!'
        node:
          typeNode: "ProgrammingLanguage"
          typeLabel: 'Programming Language'
      formFields: [{
        formItem: 'name'
        formItemLabel: 'Name'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'Name is required' }]
      }]
      sequence: [{
        fields: ['name']
      }]
  },
]



